<template>
    <div class="a-modal">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ $lang('userProfile.title') }}</span>
        </div>
        <form class="form" ref="form" @submit.prevent="submit">
            <div class="popup__content">
                <div v-if="!hideInputName" class="form__item">
                    <span class="form__label">{{ $lang('userProfile.label') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }" @focus="clearErrors"
                                  :placeholder="$lang('userProfile.placeholder')" class="input input--big" v-model="form.name"></el-input>
                    </el-popover>
                </div>
                <div class="form__item form__item--inline a-modal__separator">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('userProfile.label2') }}</span>
                        <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.phone.message || errors.phone_md5.message">
                            <div slot="reference">
                                <input-phone-by-country v-model="form.phone"
                                                        @isValid="$event => this.isValidPhone = $event"
                                                        :fetch-country="fetchCountry"
                                                        @focus="clearErrors"
                                                        :placeholder="$lang('userProfile.placeholder2')"/>
                            </div>
                        </el-popover>
                    </label>
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('userProfile.placeholder3') }}</span>
                        <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.email.message || errors.email_md5.message">
                            <el-input slot="reference"
                                      v-model="form.email"
                                      class="input input--big"
                                      :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                      @focus="clearErrors"
                                      :placeholder="$lang('userProfile.placeholder3')"
                                      :required="locale !== 'ru'"/>
                        </el-popover>
                    </label>
                </div>
                <div class="form__item a-modal__separator a-modal__password">
                    <div class="a-modal__password-header">
                        <span class="a-modal__password-title">{{ $lang('userProfile.label4') }}</span>
                        <button class="btn btn--main-bg btn--small" :disabled="disableSetPassword" @click.prevent="reset"><span>{{ $lang('userProfile.button') }}</span></button>
                    </div>
                    <div class="a-modal__password-description">
                        {{ $lang('userProfile.hint') }}
                    </div>
                </div>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg">{{ $lang('userProfile.button2') }}</button>
                <button type="button" class="btn btn--middle btn--link" @click="close">{{ $lang('userProfile.button3') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import InputPhone from "../../components/InputPhone";
import userEdit from "../../mixins/userEdit";
import InputPhoneByCountry from "../../components/InputPhoneByCountry";
import validator from "../../mixins/validator";
import Vue from "vue";

export default {
    name: "UserProfile",
    mixins: [userEdit, validator],
    components: {InputPhone, InputPhoneByCountry},
    props: {
        hideInputName: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        form: {
            id: '',
            name: '',
            email: '',
            phone: '',
        },
        isValidPhone: true,
        rules: {
            phone: {
                validator: (rule, value, cb) => { cb() }
            },
        },
        errors: {
            name: {
                isError: false,
                message: ''
            },
            email: {
                isError: false,
                message: ''
            },
            phone: {
                isError: false,
                message: ''
            },
            email_md5: {
                isError: false,
                message: ''
            },
            phone_md5: {
                isError: false,
                message: ''
            },
        },
        disableSetPassword: false,
        locale: window.laravel.locale,
        fetchCountry: false,
    }),
    created() {
        this.getProfile()
            .then((response) => {
                this.setData(
                    'form',
                    ['name', 'email', 'phone'],
                    response.data,
                    ['name', 'email', 'phone']
                );

                if (!this.form.phone) {
                    this.fetchCountry = true;
                }
            })
    },
    methods: {
        ...mapActions('miniProfile', [
            'getProfile',
            'editProfile',
            'resetPassword'
        ]),
        ...mapMutations('auth', [
            'setUser',
        ]),
        submit() {
            this.rules.phone.validator = (rule, value, cb) => {
                this.isValidPhone || value === null
                    ? cb()
                    : cb(new Error(Vue.prototype.$lang('miniProfile.invalidPhone')));
            };

            this.validate(() => {
                this.$loading(this.$optionsLoading);

                this.editProfile(this.form)
                    .then((response) => {
                        this.setUser(response.data);

                        this.$appNotify.success(Vue.prototype.$lang('userProfile.success'));

                        this.$router.go(-1);
                    })
                    .catch((error) => {
                        if (error.response.data.hasOwnProperty('errors')) {
                            this.createErrors(error.response.data.errors);
                        }
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    })
                },
                this.form,
                true
            );
        },
        reset() {
            if (!this.form.email && this.locale !== 'ru') {
                this.$appNotify.error(this.$lang('userProfile.sendPassword.emailRequired'));

                return this.errors.email = {
                    isError: true,
                    message: this.$lang('userProfile.sendPassword.emailRequired')
                }
            }

            this.$loading(this.$optionsLoading);

            this.disableSetPassword = true;

            this.resetPassword()
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('userProfile.success2'));
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                    this.disableSetPassword = false;
                });
        },
        close() {
            this.$router.go(-1);
        }
    }
}
</script>

